import { withPrefix } from 'gatsby'

const ASSETS_BASE_URL = withPrefix('/phaser/images')

export const CURSOR_SCROLLING = ASSETS_BASE_URL + '/cursor-scrolling.cur'
export const CURSOR_SCROLLING_HAND = ASSETS_BASE_URL + '/cursor-hand.cur'

// export const DEFAULT_BACKGROUND_CONTEXT = ASSETS_BASE_URL + '/park-bkg-test.jpg'
export const DEFAULT_BACKGROUND_CONTEXT = ASSETS_BASE_URL + '/park-bkg3.png'

export const DEFAULT_BACKGROUND_DROP_ELEMENT =
  ASSETS_BASE_URL + '/sticker-1.png'
export const DEFAULT_BACKGROUND_DRAG_ELEMENT =
  ASSETS_BASE_URL + '/sticker-22.png'

export const DEFAULT_LOCKED_WORD = ASSETS_BASE_URL + '/word-lock.png'
export const DEFAULT_EMPTY_WORD = ASSETS_BASE_URL + '/word-empty.png'
